import BottomSheet from '@comp/BottomSheet/BottomSheet';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import AquillaButton from 'aquilla/core/molecules/Button';
import Typography from 'aquilla/core/atoms/Typography';
import RadioButtonContainer from './RadioButtonContainer';

const Divider = styled.div`
  height: ${Spacings.SPACING_10B};
`;

const SubHeadingMobile = styled(Typography)`
  text-transform: capitalize;
  margin-bottom: 30px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 30px;
  gap: ${Spacings.SPACING_4B};
`;

const SelectionButton = styled(AquillaButton)`
  height: ${Spacings.SPACING_12B};
  flex-grow: 1;
`;

const DividerLine = styled.div`
  position: absolute;
  width: ${Spacings.SPACING_6B};
  height: ${Spacings.SPACING_2};
  left: calc(50% - 24px / 2);
  top: ${Spacings.SPACING_6B};
  background: var(--color-i-gray-13);
  border-radius: ${Spacings.SPACING_1};
`;

const MwebBottomSheet = ({
  bottomSheetWrapRef,
  filterOptions,
  filterNumberSelected,
  selectionState,
  setSelectionState,
  sessionType,
  selectedSubject,
  handleSessionTypeChange,
  handleSubjectChange,
  onClear,
  onApply
}) => {
  return (
    <BottomSheet open>
      <div ref={bottomSheetWrapRef}>
        <Divider>
          <DividerLine />
        </Divider>
        <SubHeadingMobile variant="h3">
          {filterOptions[filterNumberSelected].type}
        </SubHeadingMobile>
        <RadioButtonContainer
          selectionState={selectionState}
          setSelectionState={setSelectionState}
          filterOptions={filterOptions}
          filterNumberSelected={filterNumberSelected}
          sessionType={sessionType}
          selectedSubject={selectedSubject}
          handleSessionTypeChange={handleSessionTypeChange}
          handleSubjectChange={handleSubjectChange}
        />
        <ButtonWrapper>
          <SelectionButton variant="secondary" onClick={onClear}>
            Cancel
          </SelectionButton>
          <SelectionButton variant="primary" onClick={onApply}>
            Apply
          </SelectionButton>
        </ButtonWrapper>
      </div>
    </BottomSheet>
  );
};

export default MwebBottomSheet;
